import merge from 'lodash/merge';
import error from './error.js';
import login from './login.js';

// Translated by FANJT2024

var zh = {
  language: 'zh',
  country: 'cn',
  name: '中文',
  embeddedLocale: merge(error, login),
  flags: ['CN'],
};

export { zh as default };
